/**
 * UserAvatar — avatar com iniciais e cor determinística por id.
 */

const AVATAR_COLORS = [
  'bg-indigo-200 text-indigo-800',
  'bg-teal-200 text-teal-800',
  'bg-amber-200 text-amber-800',
  'bg-rose-200 text-rose-800',
  'bg-violet-200 text-violet-800',
  'bg-sky-200 text-sky-800',
];

function hashColor(id: string): string {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) & 0xfffffff;
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length] ?? AVATAR_COLORS[0]!;
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return '?';
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase();
}

interface Props {
  id: string;
  name: string;
  size?: 'sm' | 'md';
}

export function UserAvatar({ id, name, size = 'md' }: Props): JSX.Element {
  const color = hashColor(id);
  const sz = size === 'sm' ? 'h-7 w-7 text-xs' : 'h-9 w-9 text-sm';
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-semibold ${sz} ${color}`}
    >
      {initials(name)}
    </span>
  );
}
